import { render } from "./AddNPC.vue?vue&type=template&id=1e5120cd"
import script from "./AddNPC.vue?vue&type=script&lang=js"
export * from "./AddNPC.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__